// MCP tools run on OpenAI's side, and a finished MCP call does not start the
// model's next turn on its own: without a response.create the caller sits in
// silence until they speak or the idle timeout fires. service-ws does this for
// phone calls; on a browser call only the browser sees the event, so it asks.
//
// The rules match service-ws's turn after one of our own tools:
// - the caller is speaking: no request; their turn will use the result
// - the model is still generating: held, and sent when that response ends
//   (the API rejects a second response mid-generation)
// - otherwise: sent now
// A held request is dropped if the caller starts speaking first, and nothing
// is requested once the call is ending.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Json = any;

export const mcpTurn = (send: (msg: Json) => void, isEnding: () => boolean) => {
  let speaking = false;
  let generating = false;
  let held = false;
  // Requested and not yet started: a second MCP result in the same turn
  // needs no request of its own.
  let requested = false;

  const request = () => {
    requested = true;
    send({ type: 'response.create' });
  };

  return (event: Json) => {
    switch (event?.type) {
      case 'input_audio_buffer.speech_started':
        speaking = true;
        held = false;
        break;
      case 'input_audio_buffer.speech_stopped':
        speaking = false;
        break;
      case 'response.created':
        generating = true;
        requested = false;
        break;
      case 'response.done':
        generating = false;
        if (held) {
          held = false;
          if (!speaking && !isEnding()) request();
        }
        break;
      case 'response.mcp_call.completed':
      case 'response.mcp_call.failed':
        if (speaking || isEnding() || requested) break;
        if (generating) held = true;
        else request();
        break;
    }
  };
};
